<template>
  <div class="spot-search">
    <input
      type="text"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      placeholder="Search names & notes..."
    />
    <button
      v-if="modelValue.length > 0"
      type="button"
      class="clear-button"
      aria-label="Clear search"
      @click="$emit('update:modelValue', '')"
    >
      &times;
    </button>
  </div>
</template>

<script>
export default {
  name: 'SpotSearchBox',
  props: {
    modelValue: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
};
</script>

<style scoped>
.spot-search {
  position: relative;
  width: 100%;
}

input {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 28px 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

.clear-button {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 28px;
  border: none;
  background: none;
  color: #888;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.clear-button:hover {
  color: #333;
}
</style>
